import genericStore from "../generic_store";
import { config } from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";
import axios from "axios";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "company_stripe_update",
    object: "company",
    header: [
      { text: "ID", value: "id" },
      { text: "Question", value: "question" },
      { text: "Answer", value: "answer" },
      { text: "Actions", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions,
    generateAccountStripe({ commit, state }, data) {

      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .post(config.api_url + 'generate_stripe_link', data)
          .then(response => {
            commit("success");
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            commit("error");
            reject(error.response.data);
          });
      });
    },
    connectStripe({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
            .post(config.api_url + 'connect_oauth_stripe', data)
            .then(response => {
              commit("success");
              resolve(response.data);
            })
            .catch(error => {
              console.log(error);
              commit("error");
              reject(error.response.data);
            });
      });
    },
    accessCodeTokenOauth({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
            .post(config.api_url + 'access_oauth_stripe', data)
            .then(response => {
              commit("success");
              resolve(response.data);
            })
            .catch(error => {
              console.log(error);
              commit("error");
              reject(error.response.data);
            });
      });
    }
  },
  getters: {
    ...genericStore.getters
  }
};
